import { getUuid } from '@sravni/react-utils';

export const getOrCreateDeviceId = (): string => {
  const deviceIdKey = 'deviceId';

  try {
    // может блокироваться в некоторых устройствах
    let deviceId = localStorage.getItem(deviceIdKey);

    if (!deviceId) {
      deviceId = getUuid();
      localStorage.setItem(deviceIdKey, deviceId);
    }
    return deviceId;
  } catch (e) {
    return getUuid();
  }
};
